import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where, } from 'firebase/firestore';
import { auth, db, } from '../firebase';
import { useParams } from 'react-router-dom';

export default function Javakdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [javakitems, setjavakitems] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [updocid, setupdocid] = useState("");
    const { documentId } = useParams();

    const [productid, setproductid] = useState(" ");
    const [quantity, setquantity] = useState(0);
    const [size, setsize] = useState(" ");
    const [products, setproducts] = useState([]);


    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, "javakitems"), where("javakid", "==", documentId));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const fetchedItems = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setjavakitems(fetchedItems);
            } else {
                console.log("No matching documents found!");
            }

            const q1 = query(collection(db, 'products'))
            onSnapshot(q1, (querySnapshot) => {
                setproducts(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });


        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = javakitems.filter((item) =>
                item.data.javakpersonname.toUpperCase().includes(searchText.toUpperCase())
            );
            setjavakitems(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const handleDelete = async (docid,) => {

        const taskDocRef = doc(db, 'javakitems', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: 'Javak Itemds Data Deleted Successfully!!'
        });
        fetchData1();
    }

    const handleEdit = (id, productid, quantity, size) => {
        setupdocid(id);
        setproductid(productid)
        setquantity(quantity)
        setsize(size)
    }

    const handleUpdate = async () => {
        try {
            let product = "";
            const docRef1 = doc(db, "products", productid);
            const docSnap1 = await getDoc(docRef1);

            if (docSnap1.exists()) {
                product = docSnap1.data().product;
            } else {
                product = " ";
            }

            // Step 1: Update the specific javakitems document
            await updateDoc(doc(db, "javakitems", updocid), {
                product: product,
                productid: productid,
                quantity: parseFloat(quantity),
                size: size,
            });

            // Step 5: Show success toast
            Toast.fire({
                icon: "success",
                title: "Javak Items Updated Successfully!!"
            });

            // Step 6: Refresh data
            fetchData1();
        } catch (error) {
            console.error("Error updating documents:", error);
        }
    };


    const handleprodChange = (value) => {
        setproductid(value);
    }




    return (
        <div>
            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View Javak Items ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Sr No</th>
                                            <th>Product </th>
                                            <th>Quantity </th>
                                            <th>Size </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            javakitems.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.productid, item.quantity, item.size)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.size}</td>


                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}




            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Avak Items</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-3'>
                                    <label>Product Id</label>
                                    <input
                                        list="products-list"
                                        className="form-control"
                                        value={productid}
                                        onChange={(e) => handleprodChange(e.target.value)}
                                        placeholder="Select Product"
                                    />
                                    <datalist id="products-list">
                                        {
                                            products.map((item, index) => (
                                                <option key={index} value={item.id}>{item.data.product}</option>
                                            ))
                                        }
                                    </datalist>
                                </div>

                                <div className='col-sm-3'>
                                    <label>Quantity</label>
                                    <input type="number" value={quantity} onChange={(e) => setquantity(e.target.value)} className="form-control" />
                                </div>
                                <div className='col-sm-3'>
                                    <label>Size</label>
                                    <input type="text" value={size} onChange={(e) => setsize(e.target.value)} className="form-control" />
                                </div>
                              
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
